import firebase from 'firebase/app'
import 'firebase/auth'

export async function loginWithPasswordAndEmail({ email, password }) {
  try {
    const user = await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
    return { user }
  } catch (error) {
    window.alert('Invalid password.')
    return {
      error: error.message,
    }
  }
}
